"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headingFields = exports.headingDefaults = exports.headingShape = void 0;
const zod_1 = require("zod");
/**
 * Shared heading controls (SP5c) — size + style (normal / UPPERCASE / cursive)
 * for a section's title. Alignment comes from the shared appearance `align`.
 */
exports.headingShape = {
    headingSize: zod_1.z.enum(['sm', 'md', 'lg', 'xl']).default('md'),
    headingStyle: zod_1.z.enum(['normal', 'uppercase', 'cursive']).default('normal'),
};
const headingDefaults = () => ({ headingSize: 'md', headingStyle: 'normal' });
exports.headingDefaults = headingDefaults;
exports.headingFields = [
    { name: 'headingSize', label: 'Heading size', control: 'select', group: 'Content', options: [
            { label: 'Small', value: 'sm' }, { label: 'Medium', value: 'md' }, { label: 'Large', value: 'lg' }, { label: 'Extra large', value: 'xl' },
        ] },
    { name: 'headingStyle', label: 'Heading style', control: 'select', group: 'Content', options: [
            { label: 'Normal', value: 'normal' }, { label: 'UPPERCASE', value: 'uppercase' }, { label: 'Cursive', value: 'cursive' },
        ] },
];
//# sourceMappingURL=_heading.js.map